package one.healthium.cali.di

import one.healthium.cali.AppLaunchViewModel
import one.healthium.cali.IfaColorThemeProvider
import one.healthium.cali.appConfig
import one.healthium.cali.presentation.navigation.main.MainViewModel
import one.healthium.cali.providers.AppIconsProvider
import one.healthium.cali.providers.AppPaywallIdProvider
import one.healthium.cali.providers.AppResourceProvider
import one.healthium.data.common.serializer.ColorThemeProvider
import one.healthium.domain.paywall.PaywallIdProvider
import one.healthium.ui.compose.components.IconsProvider
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseAppResourceProvider
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val composeModule = module {
    includes(composeAppPlatformModule())

    singleOf(::AppResourceProvider) bind BaseAppResourceProvider::class
    singleOf(::AppPaywallIdProvider) bind PaywallIdProvider::class
    singleOf(::AppIconsProvider) bind IconsProvider::class

    factory { appConfig(get()) }
    factory { get<BaseAppConfig>().baseUrls }

    factoryOf(::IfaColorThemeProvider) bind ColorThemeProvider::class

    viewModelOf(::AppLaunchViewModel)
    viewModelOf(::MainViewModel)
}
